import { PartialType } from '@nestjs/swagger';
import { CreatePresupuestoDto } from './create-presupuesto.dto';

/**
 * Edición de presupuesto (sólo permitida en estado DRAFT).
 * Todos los campos son opcionales; si se envían `items`, reemplazan el detalle completo.
 */
export class UpdatePresupuestoDto extends PartialType(CreatePresupuestoDto) {}
